import UilCheck from '@iconscout/react-unicons/icons/uil-check';
import UilCopy from '@iconscout/react-unicons/icons/uil-copy';
import renderToolTip from 'pub-components/ui-controls/renderToolTip';
import React, { useEffect, useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';

const CopyIcon = ({ textToCopy }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      setCopied(true);
    }
  };

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => setCopied(false), 800);
      return () => clearTimeout(timeout);
    }
  }, [copied]);

  return copied ? (
    <OverlayTrigger
      placement="top"
      overlay={renderToolTip('Copied')}
      show={copied}
    >
      <UilCheck width={20} height={20} className="cursor-pointer ms-2" />
    </OverlayTrigger>
  ) : (
    <UilCopy
      width={20}
      height={20}
      className="cursor-pointer ms-2"
      onClick={handleCopy}
    />
  );
};

export default CopyIcon;
